import {Card, Row, Col, Divider} from 'antd';
import {CategoryType, ProductType, ProductSubType, StrainType} from "../../api/Constants";
import {Link} from 'react-router';
import {SkuWidget} from "./SkuWidget";

export const ProductInfoCard = ({item, onSkuChange, props}) => {
    const labelStyle = {
        width: 150,
        fontWeight: 'bold',
    }
    const valueStyle = {
        width: 500
    }

    const titleContent = <div>
        <b>Product</b>
    </div>

    let auxContent;
    if (item.category === CategoryType.Supplies) {
        auxContent = <div>
            <Row>
                <Col style={labelStyle}>Vendor:</Col>
                <Col style={valueStyle}>{item.company}</Col>
            </Row>
            <Row>
                <Col style={labelStyle}>Brand:</Col>
                <Col style={valueStyle}>{item.brand}</Col>
            </Row>
            <Row>
                <Col style={labelStyle}>Sku:</Col>
                <Col style={valueStyle}>
                    <SkuWidget sku={item.sku} onChange={onSkuChange}>
                        {item.sku}
                    </SkuWidget>
                </Col>
            </Row>
        </div>
    } else {
        auxContent = <div>
            <Row>
                <Col style={labelStyle}>Vendor:</Col>
                <Col style={valueStyle}>{item.company}</Col>
            </Row>
            <Row>
                <Col style={labelStyle}>Strain:</Col>
                <Col style={valueStyle}>{StrainType.Label[item.strain]}</Col>
            </Row>
            <Row>
                <Col style={labelStyle}>Sku:</Col>
                <Col style={valueStyle}>
                    <SkuWidget onChange={onSkuChange} sku={item.sku}>
                        {item.sku}
                    </SkuWidget>
                </Col>
            </Row>
        </div>
    }

    return <Card title={titleContent} width={400}>
        <Row>
            <Col style={labelStyle}>Name:</Col>
            <Col style={valueStyle}><Link to={`/product/${item.itemId}`}>{item.name}</Link></Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Description:</Col>
            <Col style={valueStyle}>{item.description}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Type:</Col>
            <Col style={valueStyle}>{ProductType.Label[item.type]}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>SubType:</Col>
            <Col style={valueStyle}>{ProductSubType.Label[item.subtype]}</Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Category:</Col>
            <Col style={valueStyle}>{CategoryType.Label[item.category]}</Col>
        </Row>
        <Divider />
        {auxContent}
    </Card>
}